/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminbypassconfirmdescription3Inputs */

const en_adminbypassconfirmdescription3 = /** @type {(inputs: Adminbypassconfirmdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will let you create and publish beyond this business's plan limits. Use only for admin support actions - the change lasts until you close this tab or disable the bypass. The business's real plan is not modified.`)
};

const de_adminbypassconfirmdescription3 = /** @type {(inputs: Adminbypassconfirmdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Damit kannst du über die Plan-Limits dieses Unternehmens hinaus Inhalte erstellen und veröffentlichen. Nur für Admin-Support verwenden – die Änderung gilt bis du den Tab schließt oder den Bypass deaktivierst. Der reale Plan des Unternehmens wird nicht verändert.`)
};

/**
* | output |
* | --- |
* | "This will let you create and publish beyond this business's plan limits. Use only for admin support actions - the change lasts until you close this tab or di..." |
*
* @param {Adminbypassconfirmdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const adminbypassconfirmdescription3 = /** @type {((inputs?: Adminbypassconfirmdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminbypassconfirmdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_adminbypassconfirmdescription3(inputs)
	return de_adminbypassconfirmdescription3(inputs)
});
export { adminbypassconfirmdescription3 as "adminBypassConfirmDescription" }